// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"7c16bed4","239":"04b5e012","455":"ebeb6b41","806":"eeb100db","977":"5893fef4"}[chunkId] + ".chunk.js";
};